// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'   //转码
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import store from '@/vuex/store'
import 'lib-flexible/flexible.js'  //自适应手机端
import MetaInfo from 'vue-meta-info' //seo优化
import Viewer from 'v-viewer/dist/v-viewer.js'
import 'viewerjs/dist/viewer.css'
// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')

// Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.use(MetaInfo)
Vue.use(Viewer)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  mounted () {
    document.dispatchEvent(new Event('render-event')) // 预渲染
  },
  components: { App },
  template: '<App/>'
})

// 走马灯预览效果
Viewer.setDefaults({
    Options: {
      'inline': true,
      'button': true,
      'navbar': true,
      'title': true,
      'toolbar': true,
      'tooltip': true,
      'movable': true,
      'zoomable': true,
      'rotatable': true,
      'scalable': true,
      'transition': true,
      'fullscreen': true,
      'keyboard': true,
      'url': 'data-source'
    }
 })



// WEBPACK FOOTER //
// ./src/main.js